// import store from "@/store/store";
// import router from "@/router";
// import {ElNotification} from "element-plus";
// import i18n from "@/i18n";

export default {
    TIMEOUT: 60000,
    REGION: 'global',

    sendRequest: async function (fetchData, tryOverRegion = false) {
        try {

            // if (!tryOverRegion && localStorage.getItem('region')) {
            //     this.REGION = localStorage.getItem('region')
            // }
            //
            // if (fetchData.path !== 'site/init') {
            //     this.TIMEOUT = 20000
            // }
            // const request = {
            //     method: 'post',
            //     path: 'user/sign-in/signup',
            //     headers: {
            //         'Content-Type': 'application/x-www-form-urlencoded'
            //     },
            //     properties: {
            //         email: user.email,
            //         password: user.password
            //     }
            // }

            let host = process.env.VUE_APP_SERVER
            // if (this.REGION === 'ru') {
            //     host = process.env.VUE_APP_SERVER_RU
            // }

            let url = new URL(host + fetchData.path);
            // if (fetchData.method === 'GET' || fetchData.method === 'get') {
            //     for (let nameParam in fetchData.params) {
            //         url.searchParams.set(nameParam, fetchData.params[nameParam]);
            //     }
            // }
            for (let nameParam in fetchData.params) {
                url.searchParams.set(nameParam, fetchData.params[nameParam]);
            }

            fetchData.credentials = "include"
            fetchData.mode = 'cors'

            if (!fetchData.headers) {
                fetchData.headers = {}
            }

            if ((fetchData.method === 'POST' || fetchData.method === 'post') && (fetchData.headers['Content-Type'] === undefined)) {
                fetchData.headers['Content-Type'] = 'application/json'
            }

            let requestBody = fetchData.body
            if (
                (fetchData.method === 'POST' || fetchData.method === 'post') &&
                fetchData.headers['Content-Type'] === 'application/json') {
                requestBody = JSON.stringify(fetchData.body)
            }

            // Adjust timeout for long-poll requests if `params.timeout` (in seconds) provided by caller
            let requestTimeout = this.TIMEOUT
            const reqTimeoutSec = Number(fetchData?.params?.timeout)
            if (!Number.isNaN(reqTimeoutSec) && reqTimeoutSec > 0) {
                // add a small buffer to server wait timeout
                requestTimeout = Math.max(requestTimeout, Math.min(60, reqTimeoutSec) * 1000 + 1000)
            }

            let response = await this.fetchWithTimeout(url.toString(), { ...fetchData, body: requestBody }, requestTimeout);

            if (!response.ok) {
                // Preserve the JSON error body (e.g. { error, reason }) alongside the status
                // code, so callers can show a specific message instead of a generic one.
                let body = null;
                try {
                    body = await response.clone().json();
                } catch (e) {
                    // non-JSON error body — ignore, server.answer is still available
                }
                return new Promise((resolve, reject) => {
                    reject({ server: { answer: response.status }, body: body?.data ?? body })
                });
                //
                // throw new Error('Service HTTP error');
            }

            if (tryOverRegion) {
                localStorage.setItem('region', this.REGION)
            }

            if (fetchData.options?.blob) {
                if (fetchData.options.returnBlob) {
                    return await response.blob()
                }

                const url = window.URL.createObjectURL(await response.blob());
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                // the filename you want
                a.download = fetchData.options.filename;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                return
            }

            let obj = await response.json()

            return new Promise((resolve, reject) => {
                if (obj && obj.status === 'success') {
                    // Common API format: { status: 'success', data: ... }
                    resolve(obj.data)
                } else if (obj && obj.success === true) {
                    // Alternate format (e.g., Custom Fields API): { success: true, ... }
                    resolve(obj)
                } else if (obj && obj.status && obj.status !== 'error') {
                    // Non-error statuses like '2fa_required' — pass through as-is
                    resolve(obj)
                } else {
                    // Normalize error payload to avoid [object Object] in UI
                    const errorPayload = obj?.errors || obj?.data || obj
                    reject(errorPayload)
                }
            });

        } catch (err) {
            // if (err.name === 'AbortError') {
            //     if (this.REGION === 'global' && fetchData.path === 'site/init') {
            //         this.REGION = 'ru'
            //         this.TIMEOUT = 20000;
            //         return this.sendRequest(fetchData, true)
            //     }
            // }

            // Caller-initiated cancellation (e.g. widget unmounted after a dashboard
            // switch) — distinguish from a real network failure so callers can just
            // drop the result instead of showing an error toast.
            if (err?.name === 'AbortError') {
                return new Promise((resolve, reject) => {
                    reject({ aborted: true })
                });
            }

            return new Promise((resolve, reject) => {

                reject({ server: { internet: false } })
            });
        }
    },

    // `options.signal`, if provided, lets the caller cancel the request early (e.g. a
    // dashboard widget unmounting or re-loading before its previous request finished).
    // It's merged with the internal timeout controller rather than passed straight to
    // fetch, since we need our own controller to fire on timeout regardless.
    fetchWithTimeout: async function (url, options = {}, timeout = 5000) {
        const controller = new AbortController()
        const id = setTimeout(() => controller.abort(), timeout)

        const externalSignal = options.signal
        let onExternalAbort = null
        if (externalSignal) {
            if (externalSignal.aborted) {
                controller.abort()
            } else {
                onExternalAbort = () => controller.abort()
                externalSignal.addEventListener('abort', onExternalAbort)
            }
        }

        return fetch(url, { ...options, signal: controller.signal })
            .finally(() => {
                clearTimeout(id) // очищаем когда всё равно вернулись
                if (externalSignal && onExternalAbort) externalSignal.removeEventListener('abort', onExternalAbort)
            });
    }
}
